/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

.measures-reanimation {
  .row > div {
    width: 25%;
    &:nth-child(2) {
      width: 20%;
    }
    &:first-child {
      width: 30%;
    }
  }
}
